module.exports = __webpack_public_path__ + "img/1569605491.51bc711f.jpg";